import { render } from "./DashboardGameMaster.vue?vue&type=template&id=59650b16"
import script from "./DashboardGameMaster.vue?vue&type=script&lang=js"
export * from "./DashboardGameMaster.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__